/** 船务订舱 Mock 数据 */

import dayjs from 'dayjs';
import type { ShipSchedule, BookingDetail, ShippingStats } from '../types';
import { ScheduleStatus } from '../types';

/** 生成相对当前时间的日期 */
function daysFromNow(days: number): string {
  return dayjs().add(days, 'day').toISOString();
}

/** 17条 mock 船期数据 */
const scheduleData: Omit<ShipSchedule, 'etd' | 'eta' | 'cutoffDate' | 'vgmCutoff'>[] = [
  { id: 'SCH001', vesselName: 'COSCO SHIPPING LEO', voyageNo: 'V087E', departurePort: '青岛港', arrivalPort: '迪拜港', totalSlots: 10, bookedSlots: 8, status: ScheduleStatus.CLOSING, carrier: 'COSCO', shippingCompany: '中远海运' },
  { id: 'SCH002', vesselName: 'MAERSK MCKINNEY', voyageNo: 'M2512', departurePort: '深圳港', arrivalPort: '鹿特丹港', totalSlots: 12, bookedSlots: 4, status: ScheduleStatus.AVAILABLE, carrier: 'MAERSK', shippingCompany: '马士基' },
  { id: 'SCH003', vesselName: 'MSC DIANA', voyageNo: 'FD841W', departurePort: '宁波港', arrivalPort: '汉堡港', totalSlots: 15, bookedSlots: 1, status: ScheduleStatus.PLENTY, carrier: 'MSC', shippingCompany: '地中海航运' },
  { id: 'SCH004', vesselName: 'CMA CGM JACQUES', voyageNo: '0PG5WE', departurePort: '青岛港', arrivalPort: '新加坡港', totalSlots: 8, bookedSlots: 5, status: ScheduleStatus.CLOSING, carrier: 'CMA CGM', shippingCompany: '达飞轮船' },
  { id: 'SCH005', vesselName: 'EVER GIVEN', voyageNo: 'EG1205', departurePort: '上海港', arrivalPort: '迪拜港', totalSlots: 10, bookedSlots: 6, status: ScheduleStatus.AVAILABLE, carrier: 'EVERGREEN', shippingCompany: '长荣海运' },
  { id: 'SCH006', vesselName: 'HMM ALGECIRAS', voyageNo: 'HMM078', departurePort: '深圳港', arrivalPort: '釜山港', totalSlots: 6, bookedSlots: 5, status: ScheduleStatus.CLOSING, carrier: 'HMM', shippingCompany: '现代商船' },
  { id: 'SCH007', vesselName: 'ONE APUS', voyageNo: '073E', departurePort: '青岛港', arrivalPort: '洛杉矶港', totalSlots: 10, bookedSlots: 3, status: ScheduleStatus.PLENTY, carrier: 'ONE', shippingCompany: '海洋网联' },
  { id: 'SCH008', vesselName: 'COSCO SHIPPING TAURUS', voyageNo: 'V2607E', departurePort: '上海港', arrivalPort: '汉堡港', totalSlots: 12, bookedSlots: 7, status: ScheduleStatus.AVAILABLE, carrier: 'COSCO', shippingCompany: '中远海运' },
  { id: 'SCH009', vesselName: 'MAERSK SELETAR', voyageNo: 'M2608E', departurePort: '宁波港', arrivalPort: '迪拜港', totalSlots: 10, bookedSlots: 2, status: ScheduleStatus.PLENTY, carrier: 'MAERSK', shippingCompany: '马士基' },
  { id: 'SCH010', vesselName: 'MSC GULSUN', voyageNo: 'FD2609', departurePort: '青岛港', arrivalPort: '鹿特丹港', totalSlots: 14, bookedSlots: 10, status: ScheduleStatus.CLOSING, carrier: 'MSC', shippingCompany: '地中海航运' },
  { id: 'SCH011', vesselName: 'CMA CGM MARCO POLO', voyageNo: '0PG2610', departurePort: '深圳港', arrivalPort: '新加坡港', totalSlots: 8, bookedSlots: 4, status: ScheduleStatus.AVAILABLE, carrier: 'CMA CGM', shippingCompany: '达飞轮船' },
  { id: 'SCH012', vesselName: 'EVERGREEN STAR', voyageNo: 'EG2611', departurePort: '上海港', arrivalPort: '釜山港', totalSlots: 10, bookedSlots: 1, status: ScheduleStatus.PLENTY, carrier: 'EVERGREEN', shippingCompany: '长荣海运' },
  { id: 'SCH013', vesselName: 'OOCL HONG KONG', voyageNo: 'OO2612', departurePort: '宁波港', arrivalPort: '洛杉矶港', totalSlots: 12, bookedSlots: 8, status: ScheduleStatus.CLOSING, carrier: 'OOCL', shippingCompany: '东方海外' },
  { id: 'SCH014', vesselName: 'YANG MING WISH', voyageNo: 'YM2613', departurePort: '青岛港', arrivalPort: '安特卫普港', totalSlots: 10, bookedSlots: 5, status: ScheduleStatus.AVAILABLE, carrier: 'YANG MING', shippingCompany: '阳明海运' },
  { id: 'SCH015', vesselName: 'WAN HAI 312', voyageNo: 'WH2614', departurePort: '深圳港', arrivalPort: '迪拜港', totalSlots: 8, bookedSlots: 2, status: ScheduleStatus.PLENTY, carrier: 'WAN HAI', shippingCompany: '万海航运' },
  { id: 'SCH016', vesselName: 'ZIM AMERICA', voyageNo: 'ZI2615', departurePort: '上海港', arrivalPort: '汉堡港', totalSlots: 10, bookedSlots: 6, status: ScheduleStatus.AVAILABLE, carrier: 'ZIM', shippingCompany: '以星航运' },
  { id: 'SCH017', vesselName: 'HAPAG LLOYD BERLIN', voyageNo: 'HL2616', departurePort: '宁波港', arrivalPort: '迪拜港', totalSlots: 12, bookedSlots: 9, status: ScheduleStatus.CLOSING, carrier: 'HAPAG LLOYD', shippingCompany: '赫伯罗特' },
];

// 动态生成日期：ETD 分布在 -5 到 +30 天之间
export const mockShipSchedules: ShipSchedule[] = scheduleData.map((s, i) => {
  const etdDays = (i % 8) - 3; // -3 到 +4
  const voyageDays = 15 + (i % 3) * 5; // 15-25天航程
  const etd = daysFromNow(etdDays);
  const eta = daysFromNow(etdDays + voyageDays);
  const cutoffDate = dayjs(etd).subtract(2, 'day').toISOString();
  const vgmCutoff = dayjs(etd).subtract(2, 'day').hour(12).toISOString();
  return { ...s, etd, eta, cutoffDate, vgmCutoff };
});

/** 5 条 mock 订舱详情（对应选中船期的 Booking） */
export const mockBookingDetails: Record<string, BookingDetail> = {
  SCH001: {
    id: 'BKG001',
    soNumber: 'SO-2025-07201',
    shippingCompany: '中远海运',
    forwarder: '上海中通货运代理有限公司',
    containerType: '40尺冷藏柜',
    containerCount: 8,
    etd: '2025-07-15T08:00:00Z',
    eta: '2025-08-10T18:00:00Z',
    cutoffDate: '2025-07-13T18:00:00Z',
    vgmCutoff: '2025-07-13T12:00:00Z',
    linkedContainers: [
      { containerNo: 'BLU-C-2601', archiveNo: 'ARV-2025-0012', type: '40尺冷藏柜' },
      { containerNo: 'BLU-C-2602', archiveNo: 'ARV-2025-0013', type: '40尺冷藏柜' },
      { containerNo: 'BLU-C-2603', archiveNo: 'ARV-2025-0014', type: '40尺冷藏柜' },
    ],
  },
  SCH002: {
    id: 'BKG002',
    soNumber: 'SO-2025-07202',
    shippingCompany: '马士基航运',
    forwarder: '深圳港联国际物流有限公司',
    containerType: '20尺干货柜',
    containerCount: 4,
    etd: '2025-07-14T14:00:00Z',
    eta: '2025-08-12T08:00:00Z',
    cutoffDate: '2025-07-12T20:00:00Z',
    vgmCutoff: '2025-07-12T14:00:00Z',
    linkedContainers: [
      { containerNo: 'MSKU900101', archiveNo: 'ARV-2025-0020', type: '20尺干货柜' },
      { containerNo: 'MSKU900102', archiveNo: 'ARV-2025-0021', type: '20尺干货柜' },
    ],
  },
  SCH003: {
    id: 'BKG003',
    soNumber: 'SO-2025-07203',
    shippingCompany: '地中海航运',
    forwarder: '宁波远东国际货运有限公司',
    containerType: '40尺冷藏柜',
    containerCount: 1,
    etd: '2025-07-20T06:00:00Z',
    eta: '2025-08-18T16:00:00Z',
    cutoffDate: '2025-07-18T16:00:00Z',
    vgmCutoff: '2025-07-18T10:00:00Z',
    linkedContainers: [
      { containerNo: 'MSCU800201', archiveNo: 'ARV-2025-0030', type: '40尺冷藏柜' },
    ],
  },
  SCH004: {
    id: 'BKG004',
    soNumber: 'SO-2025-07204',
    shippingCompany: '达飞轮船',
    forwarder: '青岛海丰国际物流有限公司',
    containerType: '40尺干货柜',
    containerCount: 5,
    etd: '2025-07-16T10:00:00Z',
    eta: '2025-07-28T12:00:00Z',
    cutoffDate: '2025-07-14T22:00:00Z',
    vgmCutoff: '2025-07-14T16:00:00Z',
    linkedContainers: [
      { containerNo: 'CMAU700301', archiveNo: 'ARV-2025-0040', type: '40尺干货柜' },
      { containerNo: 'CMAU700302', archiveNo: 'ARV-2025-0041', type: '40尺干货柜' },
      { containerNo: 'CMAU700303', archiveNo: 'ARV-2025-0042', type: '40尺干货柜' },
      { containerNo: 'CMAU700304', archiveNo: 'ARV-2025-0043', type: '40尺干货柜' },
    ],
  },
  SCH010: {
    id: 'BKG005',
    soNumber: 'SO-2025-07205',
    shippingCompany: '万海航运',
    forwarder: '深圳环球通达物流有限公司',
    containerType: '20尺冷藏柜',
    containerCount: 4,
    etd: '2025-07-17T10:00:00Z',
    eta: '2025-07-26T08:00:00Z',
    cutoffDate: '2025-07-15T20:00:00Z',
    vgmCutoff: '2025-07-15T14:00:00Z',
    linkedContainers: [
      { containerNo: 'WHLU500401', archiveNo: 'ARV-2025-0050', type: '20尺冷藏柜' },
      { containerNo: 'WHLU500402', archiveNo: 'ARV-2025-0051', type: '20尺冷藏柜' },
    ],
  },
};

/** 根据船期列表计算统计面板数据 */
export function computeShippingStats(schedules: ShipSchedule[]): ShippingStats {
  const now = dayjs();
  const monthStart = now.startOf('month');

  const monthlySailings = schedules.filter((s) => {
    const etd = dayjs(s.etd);
    return etd.isAfter(monthStart) && etd.isBefore(now.endOf('month'));
  }).length;

  const bookedSailings = schedules.filter((s) => s.bookedSlots > 0).length;
  const pendingSailings = schedules.filter((s) => s.bookedSlots === 0).length;

  const urgentCutoffs = schedules.filter((s) => {
    const cutoff = dayjs(s.cutoffDate);
    const diffHours = cutoff.diff(now, 'hour');
    return diffHours > 0 && diffHours <= 48;
  }).length;

  // "在港船舶"：简化模拟，取 ETD 在未来 3 天内的船舶
  const vesselsInPort = schedules.filter((s) => {
    const etd = dayjs(s.etd);
    const diffHours = etd.diff(now, 'hour');
    return diffHours > 0 && diffHours <= 72;
  });
  const vesselNamesInPort = vesselsInPort.map((s) => s.vesselName);

  // 平均航程天数
  const totalDays = schedules.reduce((sum, s) => {
    return sum + dayjs(s.eta).diff(dayjs(s.etd), 'day');
  }, 0);
  const avgVoyageDays = schedules.length > 0 ? Math.round(totalDays / schedules.length) : 0;

  // 准班率（模拟）
  const onTimeRate = 92;

  return {
    monthlySailings,
    bookedSailings,
    pendingSailings,
    urgentCutoffs,
    vesselsInPort: vesselsInPort.length,
    vesselNamesInPort,
    avgVoyageDays,
    onTimeRate,
  };
}
